import { useEffect, useSyncExternalStore } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib/auth/auth-context'
import { ANALYTICS_CHANGE, analyticsConsent, setAnalyticsConsent, updateMarketingAnalytics } from '@/lib/analytics/acquisition'
import { isAcquisitionPath } from '@/lib/analytics/acquisition-policy'
import { useHydrated } from '@/lib/use-hydrated'

function subscribe(change: () => void) {
  window.addEventListener(ANALYTICS_CHANGE, change)
  window.addEventListener('storage', change)
  return () => { window.removeEventListener(ANALYTICS_CHANGE, change); window.removeEventListener('storage', change) }
}

export function AnalyticsConsent() {
  const location = useLocation()
  const hydrated = useHydrated()
  const { status } = useAuth()
  const consent = useSyncExternalStore(subscribe, analyticsConsent, () => null)
  useEffect(() => {
    // Existing organization/admin sessions are not acquisition traffic.
    updateMarketingAnalytics(status === 'authenticated' || status === 'disabled' || status === 'loading')
  }, [location.pathname, location.search, consent, status])
  if (!hydrated || consent !== null || !isAcquisitionPath(location.pathname) || status === 'authenticated' || status === 'disabled') return null
  return (
    <section aria-label="Analytics preferences" className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-2xl border border-line bg-white p-4 shadow-soft sm:flex sm:items-center sm:gap-5 sm:p-5">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-ink">Allow campaign analytics?</p>
        <p className="mt-1 text-xs leading-5 text-ink-soft">We use campaign analytics and Meta to understand signups and improve our ads. Statcounter traffic analytics runs separately from this choice. <Link to="/privacy" className="underline underline-offset-2">Privacy policy</Link></p>
      </div>
      <div className="mt-3 flex gap-2 sm:mt-0">
        <Button size="sm" variant="secondary" onClick={() => setAnalyticsConsent('declined')}>Decline</Button>
        <Button size="sm" variant="secondary" onClick={() => setAnalyticsConsent('accepted')}>Allow</Button>
      </div>
    </section>
  )
}
